import React, { Component } from 'react';
import { dispatch, IRootDispatch, IRootState, state } from '../../../../stores/rematch/root-store';
import { notification } from 'antd';
import ActionModal, { ActionModalFooter } from '../../../../common-components/modal/ActionModal';
import { Paragraph } from '../../../../common-components/typography';
import { PrimaryButton, SecondaryButton } from '../../../../common-components/buttons';
import { connect } from 'react-redux';
import _ from 'lodash';

interface IApproveAllPendingTimesheetModalProps {
  isOpen: boolean;
  onClose: (isRefresh: boolean) => void;
  allPendingShiftSlots: typeof state.groupServiceStore.allPendingShiftSlots;
  selectedGroupService: typeof state.groupServiceStore.selectedGroupService;
  doApproveAllPendingShiftSlots: typeof dispatch.groupServiceStore.doApproveAllPendingShiftSlots;
}

interface IApproveAllPendingTimesheetModalState {
  title: string;
  step: number;
  canCloseOutside: boolean;
  isLoading: boolean;
  isRefreshAfterClose: boolean;
}

class ApproveAllPendingTimesheetModal extends Component<
  IApproveAllPendingTimesheetModalProps,
  IApproveAllPendingTimesheetModalState
> {
  state = {
    title: 'Approve timesheets',
    step: 1,
    canCloseOutside: true,
    isLoading: false,
    isRefreshAfterClose: false,
  };

  private _onSubmitApprove = async () => {
    const { doApproveAllPendingShiftSlots, selectedGroupService, allPendingShiftSlots } = this.props;
    this.setState({ isLoading: true, canCloseOutside: false });

    try {
      const payload = {
        serviceId: selectedGroupService.serviceId,
        supportWorkerAttendanceIds: _.map(allPendingShiftSlots, (shiftSlot) => shiftSlot.supportWorkerAttendanceId),
      };

      await doApproveAllPendingShiftSlots(payload);

      this.setState({
        isLoading: false,
        title: 'Timesheet approved',
        step: 2,
        canCloseOutside: true,
        isRefreshAfterClose: true,
      });
    } catch (e) {
      notification.error({ message: 'Oops, an error has occurred, please try again.' });
      this.setState({
        isLoading: false,
        canCloseOutside: true,
      });
    }
  };

  private _onCloseModal = () => {
    const { onClose } = this.props;
    onClose(this.state.isRefreshAfterClose);
    this.setState({
      title: 'Approve timesheets',
      step: 1,
      canCloseOutside: true,
      isLoading: false,
      isRefreshAfterClose: false,
    });
  };

  private _renderContent = () => {
    const { allPendingShiftSlots } = this.props;
    const { step } = this.state;
    const workers = _.uniqBy(allPendingShiftSlots, 'supportWorkerId');

    if (step === 1) {
      return (
        <>
          <Paragraph>
            You're about to approve <b>{allPendingShiftSlots.length}</b> shift(s) for <b>{workers.length}</b> team
            member(s).
          </Paragraph>
          <Paragraph>Would you like to proceed?</Paragraph>

          <ActionModalFooter>
            <SecondaryButton onClick={this._onCloseModal} disabled={this.state.isLoading} size="large">
              Cancel
            </SecondaryButton>
            <PrimaryButton
              onClick={this._onSubmitApprove}
              loading={this.state.isLoading}
              size="large"
              className="ml-medium"
            >
              Approve
            </PrimaryButton>
          </ActionModalFooter>
        </>
      );
    }

    if (step === 2) {
      return (
        <>
          <Paragraph>
            You've have successfully approved <b>{allPendingShiftSlots.length} shift(s)</b> for{' '}
            <b>{workers.length} team member(s)</b>.
          </Paragraph>
          <ActionModalFooter>
            <PrimaryButton onClick={this._onCloseModal} size="large">
              Close
            </PrimaryButton>
          </ActionModalFooter>
        </>
      );
    }
  };

  render() {
    return (
      <ActionModal
        isOpen={this.props.isOpen}
        title={this.state.title}
        canCloseOutside={this.state.canCloseOutside}
        onClose={this._onCloseModal}
      >
        {this._renderContent()}
      </ActionModal>
    );
  }
}

const mapState = (state: IRootState) => ({
  selectedGroupService: state.groupServiceStore.selectedGroupService,
  allPendingShiftSlots: state.groupServiceStore.allPendingShiftSlots,
});
const mapDispatch = (dispatch: IRootDispatch) => ({
  doApproveAllPendingShiftSlots: dispatch.groupServiceStore.doApproveAllPendingShiftSlots,
});

export default connect(mapState, mapDispatch)(ApproveAllPendingTimesheetModal);
